"use client";

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { validation, validationText } from "../../utils/constants.js";
import { useDispatch, useSelector } from "react-redux";
import { errorToast, formatDate, formatDateMonth, success } from "../../utils/helpers.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import { SimpleBasic, TextBasic } from "../ThemeComponent/ThemeText";
import { CrossIcon } from "../../configs/svg.js";

const OperationTheater = ({ setIsOpen, modalData}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const isLoading = useSelector((state) => state.loading); // Assuming you have a loading state in Redux
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  // Handle Image selection
  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  // Submit handler with FormData
  const onSubmit = async (data) => {
    if (!selectedImage) {
      errorToast("Please select an image to upload.");
      return;
    }

    let formData = new FormData();
    formData.append("image", selectedImage);
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("mobile_no", data.mobile_no);
    formData.append("username", data.username);

    try {
    } catch (error) {
      errorToast(error.message || "Something went wrong. Please try again.");
    }
  };

  const halfLength = Math.floor(modalData?.description?.length / 2);
  const firstHalf = modalData?.description?.slice(0, halfLength);
  const secondHalf = modalData?.description?.slice(halfLength);

  return (
    <div className="edit-profile-content">
      <div className="d-flex mb-3 justify-content-between">
        <div className="d-flex justify-content-between align-items-center">
          <TextBasic text="Task:" />
          <SimpleBasic
            text={modalData?.title}
            className={"ms-2 mb-0 fw-semibold"}
          />
        </div>
        <button
          className="cross-button outline-none rounded-circle"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <CrossIcon />
        </button>
      </div>
      <TextBasic text={firstHalf} />
      <br />
      <TextBasic text={secondHalf} />

      {/* Dates display section */}
      <div className="d-flex justify-content-between mt-4">
        <div>
          <SimpleBasic text="Assign Date" className={"mb-1 fw-semibold"} />
          <TextBasic text={formatDateMonth(modalData?.assign_date)} />
        </div>
        <div>
          <SimpleBasic text="Assign By" className={"mb-1 fw-semibold"} />
          <TextBasic text={modalData?.client?.name?.split(' ').join(', ')} />
        </div>
        <div>
          <SimpleBasic text="Hospital To " className={"mb-1 fw-semibold"} />
          <TextBasic text={modalData?.client?.hospital_name || "-"} />
        </div>
      </div>
    </div>
  );
};

export default OperationTheater;
